import { takeLeading, select, put } from 'redux-saga/effects';
import { get } from 'lodash';
import userToken from 'containers/services/security/access-token-storage';
import { callApi } from 'helpers/saga-helpers';
import { setUploadDocument } from 'containers/UploadDocuments//actions';
import {
  UPLOAD_DOCUMENT,
  REQUEST_GET_REPORTS_POLICY,
} from 'containers/UploadDocuments/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { requestCreateCorporealRegulation } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';

import {
  startLoading,
  stopLoading,
} from 'containers/AppContainer/Loader/action';
import { getTokenFromUserStorage, constructUrl } from 'services/utils';

export function* uploadDocument(action: any): Generator<unknown> {
  const token = get(userToken.get(), 'token')
    ? get(userToken.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  const path = get(userToken.get(), 'token')
    ? '/corporeal/v1/upload-documents'
    : '/corporeal/v1/upload-documents?isIntervenant=true';
  const formData = new FormData();
  formData.append(
    'document',
    get(action, 'uploadFile.regulationInfo.isRegulation')
      ? get(action, 'uploadFile.base64Url')
      : action.uploadFile,
  );
  formData.append(
    'isLawyer',
    (get(userToken.get(), 'token') ? false : true) as any,
  );
  const options = {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let result = null;
  const errorResponse = yield callApi(path, {}, options, [], e => {
    result = e;
    return setUploadDocument(e);
  });
  if (get(action, 'uploadFile.regulationInfo.isRegulation') && !errorResponse) {
    yield put(
      requestCreateCorporealRegulation(
        {
          ...get(action, 'uploadFile.regulationInfo'),
          document: { url: get(result, 'response') },
        },
        get(action, 'uploadFile.successCallBack'),
        () => {},
      ),
    );
  }
}

export function* uploadDocumentSaga() {
  yield takeLeading(UPLOAD_DOCUMENT, uploadDocument);
}

export function* requestGetReportsPolicy(action: any): Generator<unknown> {
  try {
    yield put(startLoading());
    const token =
      getTokenFromUserStorage() || (yield select(makeSelectKeycloakToken()));
    const url = constructUrl(action.url);

    yield fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.blob())
      .then(blob => {
        var _url = window.URL.createObjectURL(blob);
        //@ts-ignore
        window.open(_url, '_blank');
      })
      .catch(err => {
        throw err;
      });
  } catch (err) {
  } finally {
    yield put(stopLoading());
  }
}
export function* requestGetReportsPolicySaga() {
  yield takeLeading(REQUEST_GET_REPORTS_POLICY, requestGetReportsPolicy);
}

export default [uploadDocumentSaga, requestGetReportsPolicySaga];
